function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.00008 0.666016C3.95632 0.666016 0.666748 3.95559 0.666748 7.99935C0.666748 12.0431 3.95632 15.3327 8.00008 15.3327C12.0438 15.3327 15.3334 12.0431 15.3334 7.99935C15.3334 3.95559 12.0438 0.666016 8.00008 0.666016ZM11.4877 11.7925C11.3685 11.9116 11.2121 11.9716 11.0557 11.9716C10.8992 11.9716 10.7427 11.9116 10.6236 11.7925L7.56804 8.73698C7.45312 8.62273 7.38901 8.46742 7.38901 8.30494V4.33268C7.38901 3.99475 7.66271 3.72161 8.00008 3.72161C8.33745 3.72161 8.61116 3.99475 8.61116 4.33268V8.05194L11.4877 10.9284C11.7266 11.1674 11.7266 11.5536 11.4877 11.7925Z",
  fill: "#373737"
});

function SvgWorkingHours(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingHours);
export default __webpack_public_path__ + "static/media/working-hours.cfcdcd2c.svg";
export { ForwardRef as ReactComponent };